export const enum StatementStatus {
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  DISTRIBUTED = 'DISTRIBUTED',
  PROCESSED = 'PROCESSED',
  SUSPENDED = 'SUSPENDED',
  REJECTED = 'REJECTED',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  IN_PROGRESS = 'IN_PROGRESS',
  PROCESSED_FROM_FSSP = 'PROCESSED_FROM_FSSP',
  SENT_TO_FSSP = 'SENT_TO_FSSP',
  SUSPENDED_DOCUMENTS_PROVIDED = 'SUSPENDED_DOCUMENTS_PROVIDED',
  SUSPENDED_AWAITING_DOCUMENTS = 'SUSPENDED_AWAITING_DOCUMENTS',
  QUITTANCE_PROVIDED = 'QUITTANCE_PROVIDED',
  DRAFT = 'DRAFT',
}
